import { Button, Typography, LazyImage } from '@frontend/design_system'
import reviewImgSrc from 'assets/img/review.webp'
import { URLS } from 'constants/urls'
import { useNavigate } from 'react-router-dom'
import styles from './styles.module.scss'
import { REVIEW_BLOCK } from 'texts/reviewBlock'

export const ReviewBlock = ({ isApproved }: { isApproved: boolean }) => {
  const navigate = useNavigate()
  const goToDashboard = () => {
    navigate(URLS.DASHBOARD)
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <LazyImage src={reviewImgSrc} width={197} height={131} />
        <Typography name="subtitleWBold">
          {isApproved ? REVIEW_BLOCK.TITLE_APPROVED : REVIEW_BLOCK.TITLE}
          <Typography Tag="p" name="subtitleWBold">
            {!isApproved && REVIEW_BLOCK.SUBTITLE}
          </Typography>
        </Typography>
        <Typography Tag="p" name="body1WMedium">
          {isApproved
            ? REVIEW_BLOCK.DESCRIPTION_APPROVED
            : REVIEW_BLOCK.DESCRIPTION}
        </Typography>
        <Button
          onClick={goToDashboard}
          variant="link"
          label={REVIEW_BLOCK.BUTTON_LABEL}
          color="blackMaster"
          linkHover="secondary"
        />
      </div>
    </div>
  )
}
